"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
class AnalystPersistence {
    constructor(params = {}) {
        this.user_id = null;
        this.id = 0;
        this.client_id = (0, uuid_1.v4)();
        this.list = [];
        this.storage = null;
        if (params.storage)
            this.storage = params.storage;
    }
    getPersistedConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                return null; // or defaults
            const data = yield this.storage.getState();
            return data;
        });
    }
    savePersistedConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                return null;
            const config = { client_id: this.client_id, id: this.id, user_id: this.user_id };
            yield this.storage.setState(config);
        });
    }
    resetStore() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.storage)
                return null;
            yield this.storage.reset();
        });
    }
    setupNewClient() {
        this.client_id = (0, uuid_1.v4)();
        this.id = 0;
        this.user_id = null;
        this.savePersistedConfig();
    }
    initConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const config = yield this.getPersistedConfig();
            if (config) {
                this.client_id = config.client_id;
                this.id = config.id;
                if (!this.user_id)
                    this.user_id = config.user_id;
            }
            else {
                this.setupNewClient();
            }
        });
    }
}
exports.default = AnalystPersistence;
